<template>
  <form @submit.prevent="">
    <z-dialog :show="isVisible" :modal-size="modalSize">
      <template #header>
        <div class="custom-header">
          <div class="row">
            <div class="col-md-11">
              <h4 class="modal-title">Email</h4>
            </div>
            <div class="col-md-1">
              <a href="#" class="custom-close" @click="close">
                <i class="fa fa-times"></i>
              </a>
            </div>
          </div>
        </div>
      </template>
      <template #body>
        <contact-summary class="ms-4" :record="value" />
        <div class="form-control custom-form">
          <z-select v-model="emailType" label="Email Type" name="emailType" :options="lookups['EmailType']" :validator="v$" />
          <z-input v-model="emailAddress" name="EmailAddress" label="Email" :validator="v$" />
        </div>
      </template>
      <template #footer>
        <button type="button" class="btn btn-light" @click="close()">Cancel</button>
        <button type="submit" class="btn btn-primary" @click="save()">Save</button>
      </template>
    </z-dialog>
  </form>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { contactStore } from '@/stores/contact'
import { lookupStore } from '@/stores/lookup'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import ZDialog from '@/components/utilities/elements/Dialog.vue'
import ZInput from '@/components/utilities/elements/Input.vue'
import ZSelect from '@/components/utilities/elements/Select.vue'
import ContactSummary from '@/components/contact/forms/ContactSummary.vue'
export default {
  name: 'ContactEmail',
  components: {
    ZDialog,
    ZInput,
    ZSelect,
    ContactSummary
  },
  props: {
    modelValue: {
      type: Object
    }
  },
  data() {
    return {
      modalSize: null,
      rules: {
        emailType: { required },
        emailAddress: { required }
      },
      v$: null
    }
  },
  emits: ['input', 'closing', 'send'],
  computed: {
    ...mapState(lookupStore, ['lookups']),
    ...mapState(contactStore, ['loading', 'email']),
    emailType: {
      get() {
        return this.email !== null ? this.email.emailType : 0
      },
      set(value) {
        this.setEmail({
          name: 'emailType',
          value: parseInt(value)
        })
      }
    },
    emailAddress: {
      get() {
        return this.email !== null ? this.email.emailAddress : ''
      },
      set(value) {
        this.setEmail({
          name: 'emailAddress',
          value: value
        })
      }
    },
    isVisible: {
      get() {
        let _is = false
        if (this.modelValue) {
          _is = true
          this.init()
        }
        return _is
      }
    }
  },
  methods: {
    ...mapActions(contactStore, ['setEmail']),
    init() {
      this.v$ = useVuelidate(this.rules, this.email)
    },
    close() {
      this.$emit('closing')
    },
    async save() {
      const valid = await this.v$.$validate()
      if (valid) {
        this.$emit('send', this.email.contactEmail)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}
.custom-close {
  float: right;
  margin-right: 10px;
  color: #000;
  cursor: pointer;
}
.custom-subtitle {
  font-size: 0.9em;
}
.custom-form {
  text-align: left;
  max-height: 200px;
  height: 200px;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
